<template>
  <div class="dod33 js-cursor" id="dod33">
    <div class="anchor-to-bottom js-cursor-target">
      <icon name="iconSearch" type="full" />
    </div>
  </div>
</template>

<script>
import { TweenMax, Power2, Power4 } from 'gsap/TweenMax'

export default {
  name: 'dod33',

  data: () => ({
    ready: false,
    mouse: {
      x: 0,
      y: 0,
      sx: 0,
      sy: 0,
      cx: 0,
      cy: 0
    }
  }),

  methods: {
    init() {
      const targets = [...document.querySelectorAll('#dod33.js-cursor')]

      targets.forEach(cursor => {
        cursor.addEventListener('mouseenter', this.onMouseEnter, false)
        cursor.addEventListener('mouseleave', this.onMouseLeave, false)
        cursor.addEventListener('touchstart', this.onMouseEnter, false)
        cursor.addEventListener('touchend', this.onMouseLeave, false)
      })

      window.addEventListener('mousemove', this.onWindowMouseMove, false)
      window.addEventListener('touchmove', this.onWindowMouseMove, false)
    },

    destroy() {
      const targets = [...document.querySelectorAll('#dod33.js-cursor')]

      targets.forEach(cursor => {
        cursor.removeEventListener('mouseenter', this.onMouseEnter, false)
        cursor.removeEventListener('mouseleave', this.onMouseLeave, false)
        cursor.removeEventListener('touchstart', this.onMouseEnter, false)
        cursor.removeEventListener('touchend', this.onMouseLeave, false)
      })

      window.removeEventListener('mousemove', this.onWindowMouseMove, false)
      window.removeEventListener('touchmove', this.onWindowMouseMove, false)
    },

    onWindowMouseMove(e) {
      let x = 0
      let y = 0

      if (e.touches && e.touches[0]) {
        x = e.touches[0].clientX
        y = e.touches[0].clientY
      } else if (e.originalEvent && e.originalEvent.changedTouches[0]) {
        x = e.originalEvent.changedTouches[0].clientX
        y = e.originalEvent.changedTouches[0].clientY
      } else if (e.clientX && e.clientY) {
        x = e.clientX
        y = e.clientY
      }

      this.mouse.sx = x
      this.mouse.sy = y

      this.onMouseMove()
    },

    onMouseEnter(e) {
      this.ready = true

      this.$area = e.target
      this.$cursor = e.target.querySelector('.js-cursor-target')

      const { width, height } = this.$cursor.getBoundingClientRect()
      this.w = width
      this.h = height

      const { left, top } = this.$area.getBoundingClientRect()
      this.tx = this.mouse.sx - left
      this.ty = this.mouse.sy - top

      TweenMax.set(this.$cursor, {
        x: this.tx - (this.w / 2) + 'px',
        y: this.ty - (this.h / 2) + 'px'
      })
    },

    onMouseMove() {
      if (!this.ready) {
        return
      }

      const { left, top } = this.$area.getBoundingClientRect()
      this.tx = this.mouse.sx - left
      this.ty = this.mouse.sy - top

      TweenMax.to(this.$cursor, 0.2, {
        x: this.tx - (this.w / 2) + 'px',
        y: this.ty - (this.h / 2) + 'px',
        alpha: 1,
        ease: Power2.easeOut
      })
    },

    onMouseLeave(e) {
      this.ready = false

      TweenMax.to(this.$cursor, 0.1, {
        alpha: 0,
        ease: Power4.easeOut
      })
    }
  },

  beforeDestroy() {
    this.destroy()
  },

  mounted() {
    this.init()
  }
}
</script>

<style scoped lang="scss">
.dod33 {
  @include FR_FULLSIZE;

  z-index: 10;
}

.anchor-to-bottom {
  display: block;
  height: 120px;
  width: 120px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  backface-visibility: hidden;
  will-change: transform, opacity;
}
</style>
